import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import PageTracker from '../../../../common/PageTrackerHelper'

export default {
  name: 'LogisticMarkDebitTransitApproval',
  components: {
    VueElementLoading,
    Paginate,
  },
  mixins:[PageTracker],
  data: function() {
    return {
      isShowing:false,
      debitfrom: '',
      fromDate:'',
      toDate:'',
      status:'Pending',
      ddldebitmode:'',
      hubname:0,
      hubServiceCenterList:[],
      pageno: 1,
      pagecount: 0,
      shipmentlogmodal: false,
      isLoading: false,
      isImageLoading : false,
      shippingid : '',
      depositDate : '',
      shipmentList : '',
      getUploadError : [],
      validated : true,
      attachmentPath : '',
      form:{
          shippingidchk:[],
          values:[],
          checkboxval:[]
      },
      getAttachmentFlag: false,
      attachmentLoader: false,
      getAttachmentListData: [],
      searchTransitApprovalLoader: false,
      TransitApproveLoaderbtn: false,
      totalRecord:0,
      selectedCount:0,
      exportFlag:false,
      selectAllItems: false,
      lostMasterId : [],
      shippingIdForMeta : [],
      Vertical : ''
    }
  },
  created: function() {
  },
  async mounted() {
    let validateUser = await this.validateJwtToken();
    //this.getHubServiceCenterData();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;

    //console.log('Mixin is working for :',result);
  },
  methods: {
    selectItems(ev) {
      this.form.shippingidchk = [];
      if (ev.target.checked == true) {
          for (let i in this.shipmentList) {
            this.form.shippingidchk.push(this.shipmentList[i].ShippingID.toString());
          }
      }
      this.selectedCount = this.form.shippingidchk.length
      //this.calculateDebitAmout(this.amount,100);
    },
    calculateselectedcount(){
     this.selectedCount = this.form.shippingidchk.length
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        //alert("Form1 Submitted")
        if (result) {
          //scope.chkSelect = this.chkSelect.join(',');
          //scope.availability = this.availability.join(',');
          let temparr = [];
          let shipmentArr = [];
          if(this.form.shippingidchk.length==0){
            this.$alertify.error("Please select shipment(s)!");
          } else {
            //console.log(this.form.shippingidchk);
            this.TransitApproveLoaderbtn = true
            let payload = [];
          this.form.shippingidchk.forEach((item)=>{

            let tempArr = item.split('_');
            this.shippingIdForMeta = tempArr[0]
            const result = this.shipmentList.find( ({ ShippingID }) => ShippingID === item );

            let approvedBy = this.localusermailid;
            this.lostMasterId = result.ShipmentLostMasterID
            let shipmentObj = {
                       "ShippingID":tempArr[0],
                       "DebitMode":this.ddldebitmode,
                       "DepositDate":(this.depositDate!=undefined)?this.depositDate:'',
                       "FileUpload": this.attachmentPath != '' ? this.attachmentPath : undefined,
                       "ApprovalBy":approvedBy,
                       "ShipmentLostMasterID": result.ShipmentLostMasterID,
                       "ShipmentLostDetailsID": result.ShipmentLostDetailsID,
                       "DebitAmount": result.DebitAmount,
                     };
                     payload.push(shipmentObj);
          });

          //console.log('payload',payload);
          axios.post(apiUrl.api_url + 'transitApproval/confirm', payload)
            .then((response) => {
              //console.log('response',response.data.code);
              if(response.data.code == 200){
                let masterID = String(this.lostMasterId)
                let TrackerInfo = {
                  projectname:"Last Mile",
                  type:"Web",
                  userid:this.localuserid,
                  username:this.localusermailid,
                  meta: {
                      "event":"approveTransitApprovalData",
                      "DebitMode":this.ddldebitmode,
                      "ShippingID":this.shippingIdForMeta

                    }
                  }
                  this.PageTracker(TrackerInfo);
                this.$alertify.success("Success!");
              } else{
                this.$alertify.error('Failed to transit approve');
              }
              this.form.shippingidchk = [];
              this.selectAllItems = false
              this.shipmentList=[];
              this.resetFormApprove();
              this.searchTransitApprovalData();
              this.TransitApproveLoaderbtn = false
              this.selectedCount = 0
              //console.log('response', response);
            }).catch((httpException) => {
              this.TransitApproveLoaderbtn = false
              this.$alertify.error("Failed to transit approve!");
              console.error('exception is:::::::::', httpException)
            });
          }
        }
      }).catch(() => {
        this.TransitApproveLoaderbtn = false
        console.log('errors exist', this.errors)
      });
    },
    getHubListByDabit(event) {
      axios.post(apiUrl.api_url + 'hubByDebitType/list', {"DebitFrom":event.target.value})
        .then((response) => {
            if(response.data.code===200){
                this.hubServiceCenterList=response.data.data;
            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
              //this.$alertify.success("Client data not found");
              console.error('exception is:::::::::', httpException)
        })

    },

    //to get pagination
    getPaginationData(pageNum) {
      //console.log('pageNum',pageNum);
        this.selectAllItems = false
        this.pageno = pageNum;
        this.searchTransitApprovalData();
    },
    searchData() {
      this.isShowing = true;
      this.pageno = 1;
      this.$refs.paginate.selected= 0;
      this.searchTransitApprovalData();
    },
    //search Raise Debit data
    searchTransitApprovalData(){
    //  console.log("In Function");
          console.log('shippingid',this.shippingid);
          console.log('Vertical',this.Vertical);
          let payload = {};
          if(this.fromDate!='') payload.FromDate = this.fromDate;
          if(this.toDate!='') payload.ToDate = this.toDate;
          if(this.hubname!=0) payload.HubID = this.hubname;
          if(this.status!='') payload.Status = this.status;
          if(this.debitfrom!='') payload.DebitFrom = this.debitfrom;
          if(this.shippingid!=undefined) payload.ShippingID = (this.shippingid !='' ? this.shippingid : undefined);
          if(this.Vertical!='') payload.Vertical = this.Vertical;
          payload.pageNo = this.pageno;
          payload.pageSize = 100;
          this.searchTransitApprovalLoader = true
          if(this.exportFlag == true){
            payload.exportFlag = "1"
          }
          axios.post(apiUrl.api_url + 'transitApproval/list', payload)
            .then((response) => {
                if(response.data.code==200){
                //  console.log(response.data.code);
                  let shipmentListData = response.data.data;
                  console.log('shipmentListData',shipmentListData);
                  let temparr = [];
                  let temparrCSV = [];
                  if(shipmentListData!=null){
                    response.data.data.forEach((shipment)=>{
                      var newcreateddate = this.changeDateFormat(shipment.CreatedDate);
                      var newcLastModifiedDate = this.changeDateFormat(shipment.LastModifiedDate);
                      var newCIHDepositDate = this.changeDateFormat(shipment.CIHDepositDate);
                      var checkboxval = shipment.ShippingID;
                      shipment.CreatedDate = newcreateddate;
                      shipment.LastModifiedDate = newcLastModifiedDate;
                      shipment.CIHDepositDate = newCIHDepositDate;
                      shipment.checkboxval = checkboxval.toString();
                      temparrCSV.push({"ClientName":shipment.ClientName,
                                   "ShippingID":shipment.ShippingID,
                                   "Status":shipment.Status,
                                   "DebitFromType":shipment.DebitFromType,
                                   "DebitFromName":shipment.DebitFrom,
                                   "DebitAmount":shipment.DebitAmount,
                                   "DepositDate":newCIHDepositDate,
                                   "HubName":shipment.HubName,
                                   "HubZoneName":shipment.HubZoneName,
                                   "Comments":shipment.Comments,
                                   "DocketNo":shipment.DocketNumber,
                                   "CreatedBy":shipment.CreatedBy,
                                   "CreatedDate":newcreateddate,
                                   "LastModifiedBy":shipment.LastModifiedBy,
                                   "LastModifiedDate":newcLastModifiedDate
                                 });
                    });
                  }
                    this.shipmentList=response.data.data;
                    this.shipmentListCSV=temparrCSV;
                    if(this.exportFlag == true){
                        this.getDownloadCsvObject(this.shipmentListCSV);
                    }

                    let totalRows = response.data.toalCount;
                    this.isShowing=true;
                    this.totalRecord = totalRows
                    if (totalRows < 100) {
                        this.pagecount = 1
                    } else {
                        this.pagecount = Math.ceil(totalRows / 100)
                    }
                } else {
                    this.shipmentList=[];
                    this.$alertify.error(response.data.message);
                }
                this.searchTransitApprovalLoader = false
                console.log('shipmentList',this.shipmentList);
            })
            .catch((httpException) => {
                  this.searchTransitApprovalLoader = false
                  this.$alertify.error("No Records Found!");
                  console.error('exception is:::::::::', httpException)
            });
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.searchRaiseDebitData(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    getShipmentAttachmentPopup(shippingID){
      this.attachmentLoader = true
      this.getAttachmentFlag= true
      let data={
        ShippingID: shippingID
      }
      axios.post(apiUrl.api_url + 'Lost/ShippindID/AttachmentDownload',data)
        .then((response) => {
            if(response.data.code == 200){
               this.getAttachmentListData = response.data.data;
            } else {
              this.getAttachmentListData = [];
            }
            this.attachmentLoader = false;
          })
        .catch((httpException) => {
             this.attachmentLoader = false;
            console.error('exception is:::::::::',httpException)
        });
    },
    exportForm(){
      if(this.shipmentListCSV==undefined || this.shipmentListCSV.length==0){
        this.$alertify.alert("No data","No data available for download.");
      }
      this.exportFlag = true
      this.searchTransitApprovalData()
    },
    changeDateFormat(inputString){
      if(inputString != null) {
        let current_datetime = new Date(inputString)
        let formatted_date = current_datetime.getDate() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getFullYear();
        return formatted_date;
      } else {
        return '-'
      }

    },
    getDownloadCsvObject(result) {
      this.exportFlag = false
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "MarkLostShipment_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },
    convertArrayOfObjectsToCSV: function(args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      keys = Object.keys(data[0]).slice(0);
      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;
      data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {
          if (ctr > 0) result += columnDelimiter;
          if (item[key] != null) {
            result += '"' + item[key] + '"';
          }
          ctr++;
        });
        result += lineDelimiter;
      });
      return result;
   },
   onUpload(event){
     this.getUploadError = [];
     const file = event.target.files[0];
     this.file = file;
     //console.log('file.size',this.file.size);
     this.isImageLoading = true;
     this.validated = false;

     //image upload code start here
     const formData = new FormData();
     const microtime = new Date().getTime();
     let setTransitApprovalPath = `${microtime}_transiteApprove`
     formData.append('ShippingID', setTransitApprovalPath);
     formData.append('file',this.file);
     if(this.file.size <= 1024 * 1024 * 5) {
       axios.post(apiUrl.api_url + 'raiseDebit/LostFileUploads', formData)
        .then((response) => {
          if(response.data.code === 200) {
            this.getUploadError = [{'title':'success','detail':'file Uploaded successfully !!'}];
            this.attachmentPath = response.data.imageUrl;
            this.uploadError = this.getUploadError.length;
            //console.log('this.attachmentPath',this.attachmentPath);
            this.validated = true;
          } else {
            this.uploadError = '';
            this.attachmentPath = '';
            this.getUploadError = response.data.errors;
            //console.log('this.getUploadError',this.getUploadError);
            const input = this.$refs.UploadFile;
            input.type = 'text';
            input.type = 'file';
            this.validated = false;
          }
            this.isImageLoading = false;
        })
        .catch((httpException) => {
            console.error('exception is :::::::::', httpException)
            this.isImageLoading = false;
            this.isAPICallFlag = false;
        })
     } else {
       this.$alertify.error("Please check image size should be less than 5MB ");
       const input = this.$refs.UploadFile;
       input.type = 'text';
       input.type = 'file';
       this.validated = true;
       this.isImageLoading = false;
     }
     //image upload code end here

   },
    resetForm() {
      //ddldebitmode
        this.Vertical = '';
        this.client = 0;
        this.hubzone = 0;
        this.hubname = 0;
        this.amount = 0;
        this.shippingid = '';
        this.amountcomparator = 0;
        this.netpaymnet = '';
        this.gapdays = 0;
        this.txtgapdays = '';
        this.gapdayscomparator = 0;
        this.pageno = 1;
        this.$refs.paginate.selected= 0;
        this.ddldebitmode = '';
        this.form.shippingidchk = [];
        this.isShowing=false;
        this.shipmentList = [];
        this.getUploadError = []
        this.attachmentPath = '';
        this.debitfrom = '';
        this.fromDate = '';
        this.toDate = '';
        const input = this.$refs.UploadFile;
        input.type = 'text';
        input.type = 'file';
        this.$validator.reset();
        this.errors.clear();
    },
    resetFormApprove() {
        this.Vertical = '';
        this.ddldebitmode = '';
        this.form.shippingidchk = [];
        this.shipmentList = [];
        document.getElementById('checkbox1').checked = false;
        const input = this.$refs.UploadFile;
        this.getUploadError = [];
        input.type = 'text';
        input.type = 'file';
        this.attachmentPath = '';
        this.selectedCount = 0 ;
        this.$validator.reset();
        this.errors.clear();
    },
    closeAttachmentPopup(){
     this.getAttachmentFlag = false
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/LOST/LogisticMarkDebitTransitApproval/LogisticMarkDebitTransitApproval.component.js